var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"case-report"},[_c('graph-triple-panel',{attrs:{"graph-title":"三元组关系图","table-title":"三元组数据表","graph-data":_vm.graphData,"triples":_vm.triples,"page-size":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }